var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriptionPaused(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-subscription-paused"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "subscription-paused",
    clipPath: "url(#clip-subscription-paused)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22039",
    "data-name": "Group 22039"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19601",
    "data-name": "Group 19601"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18810",
    "data-name": "Group 18810"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7241",
    "data-name": "Group 7241"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6994",
    "data-name": "Group 6994"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24017",
    "data-name": "Rectangle 24017",
    width: 20,
    height: 20,
    rx: 10,
    fill: "#fab242"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19612",
    "data-name": "Group 19612",
    transform: "translate(13439.074 12732.869)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34138",
    "data-name": "Path 34138",
    d: "M222.728,345.757a1.065,1.065,0,1,1-1.065-1.065A1.065,1.065,0,0,1,222.728,345.757Zm0,0",
    transform: "translate(-13650.737 -13064.497)",
    fill: "#35495e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34139",
    "data-name": "Path 34139",
    d: "M221.663,71.035a1.065,1.065,0,0,1,1.065,1.065v5.06a1.065,1.065,0,0,1-2.131,0V72.1A1.065,1.065,0,0,1,221.663,71.035Zm0,0",
    transform: "translate(-13650.737 -12799.098)",
    fill: "#35495e"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionPaused);
export default __webpack_public_path__ + "static/media/subscription-paused.4258a836ffdfdd4ebca483638f59b882.svg";
export { ForwardRef as ReactComponent };